module.exports = __webpack_public_path__ + "img/franchising_why_4.a6ffa370.svg";